export enum CONTRACTOR_TYPE_ENUM {
  All = 0,
  Issuer = 1,
  Buyer = 2,
  Receiver = 3,
  Payer = 4,
  Middleman = 5,
  Seller = 6,
  OrganizationalUnit = 7,
  Factor = 8,
  CashReportReceiver = 100,
}
